module.exports = __webpack_public_path__ + "img/0-12.cf8fc8bf.gif";